module.exports = __webpack_public_path__ + "img/gustav-weber.1cf62c38.png";